import { Col, Modal, Row } from "antd";
import React, { useMemo } from "react";
import styles from "./RecallConfirmationModal.module.scss";
import {
  getBatchDetails,
  getFormattedInvoiceList,
  getInvoiceIdText,
  invoiceStatusColumns,
  RecallConfirmationModalConsts,
} from "./constants";
import TNLoader from "../../../../reusable-components/TNLoader";
import InvoiceManagementServices from "../../../../services/invoiceManagement.service";
import { RecallInvoiceDetailsType } from "../../../../Types/invoiceManagementTypes";
import CustomTableWithPagination from "../../../../reusable-components/CustomTable";
import clsx from "clsx";
import TNButton from "../../../../reusable-components/TNButton";
import ModalFooterContent from "../../../../reusable-components/ModalFooterContent";
import { FooterType } from "../../../../enums/ModalEnums";

interface RecallConfirmationModalProps {
  isOpen: boolean;
  handleClose: () => void;
  handleCancel: () => void;
  handleConfirm: (invoiceId: string) => void;
  invoiceDetails: RecallInvoiceDetailsType;
}

const RecallConfirmationModal = ({
  isOpen,
  handleClose,
  handleCancel,
  handleConfirm,
  invoiceDetails,
}: RecallConfirmationModalProps) => {
  const {
    MODAL_TITLE,
    MODAL_WIDTH,
    TABLE_SIZE,
    SCROLL_BEHAVIOUR,
    RECALL_DETAILS_HEADER,
    MAIN_MESSAGE,
    NOTE_HEADER,
    NOTE_MESSAGE,
  } = RecallConfirmationModalConsts;

  const handleCancelAction = () => {
    handleClose();
    handleCancel();
  };

  const handleOkAction = () => {
    handleConfirm();
    handleClose();
  };

  const invoiceIdsFormatted = useMemo(
    () => getFormattedInvoiceList(invoiceDetails?.invoices),
    [invoiceDetails],
  );

  return (
    <>
      <TNLoader isLoading={false} />
      <Modal
        visible={isOpen}
        onCancel={handleCancelAction}
        title={MODAL_TITLE}
        width={MODAL_WIDTH}
        footer={
          <ModalFooterContent
            messageHeader={NOTE_HEADER}
            messageContent={NOTE_MESSAGE}
            footerType={FooterType.STANDARD_TWO}
            okButtonAction={handleOkAction}
            cancelButtonAction={handleCancelAction}
          />
        }
        destroyOnClose
      >
        <div className={styles.confirmationContainer}>
          <div className={styles.confirmationInfo}>{MAIN_MESSAGE}</div>
          <div className={styles.confirmationInfo}>
            {getInvoiceIdText(invoiceIdsFormatted)}
          </div>
          <div className={clsx(styles.confirmationInfo, styles.tableContainer)}>
            <CustomTableWithPagination
              columns={invoiceStatusColumns}
              className={styles.invoiceStatusTable}
              dataSource={invoiceDetails?.invoices}
              size={TABLE_SIZE}
              showPagination={false}
              scroll={SCROLL_BEHAVIOUR}
            />
          </div>
          <div className={styles.batchDetails}>
            <div className={styles.batchDetailsHeader}>
              {RECALL_DETAILS_HEADER}
            </div>
            <Row 
              gutter={[12, 12]}
            >
              {getBatchDetails(invoiceDetails)?.map((item) => {
                return (
                  <Col span={item.span}>
                    <div className={styles.valueItem}>
                      <div className={styles.valueText}>{item.value}</div>
                      <div className={styles.labelText}>{item.label}</div>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default RecallConfirmationModal;
